import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Layout from "./component/Layout";
import Nav from "./component/Nav";
import HomePage from "./component/HomePage";
import Resume from "./component/Resume";
import Blog from "./component/Blog";
import Contact from "./component/Contact";
import Footer from "./component/Footer.js";

function App() {
  return (
    <React.Fragment>
      <Layout>
        <Router>
          <Nav />
          <Switch>
            <Route path="/" exact component={HomePage} />
            <Route path="/profile" component={Resume} />
            <Route path="/blog" component={Blog} />
            <Route path="/contact" component={Contact} />
          </Switch>
        </Router>
        <Footer />
      </Layout>
    </React.Fragment>
  );
}

export default App;
